export const SUBSCRIPTION_ACTIVATE_REQUEST = "SUBSCRIPTION_ACTIVATE_REQUEST";
export const SUBSCRIPTION_ACTIVATE_SUCCESS = "SUBSCRIPTION_ACTIVATE__SUCCESS";
export const SUBSCRIPTION_ACTIVATE_FAIL = "SUBSCRIPTION_ACTIVATE_FAIL";
export const SUBSCRIPTION_ACTIVATE_RESET = "SUBSCRIPTION_ACTIVATE_RESET";

export const SUBSCRIPTION_PAY_REQUEST = "SUBSCRIPTION_PAY_REQUEST";
export const SUBSCRIPTION_PAY_SUCCESS = "SUBSCRIPTION_PAY_SUCCESS";
export const SUBSCRIPTION_PAY_FAIL = "SUBSCRIPTION_PAY_FAIL";
export const SUBSCRIPTION_PAY_RESET = "SUBSCRIPTION_PAY_RESET";

export const SUBSCRIPTION_DETAILS_REQUEST = "SUBSCRIPTION_DETAILS_REQUEST";
export const SUBSCRIPTION_DETAILS_SUCCESS = "SUBSCRIPTION_DETAILS_SUCCESS";
export const SUBSCRIPTION_DETAILS_FAIL = "SUBSCRIPTION_DETAILS_FAIL";
export const SUBSCRIPTION_DETAILS_RESET = "SUBSCRIPTION_DETAILS_RESET";
